import clr from './colors.module.scss';
import invclr from './colors.inverse.module.scss';

export const color = clr;
export const invColor = invclr;
